/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">All Plans</h4>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">Title</th>
                        <th scope="col">Price</th>
                        <th scope="col">Duration</th>
                        <th scope="col">Target</th>
                        <th scope="col">Take Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="plan in plans" :key="plan._id">
                        <th>{{plan.title}}</th>
                        <td>{{plan.price}}</td>
                        <td>{{plan.duration}}</td>
                        <td>{{plan.target}}</td>
                        <td>

                            <router-link :to="{ name: 'EditPlan', params : {planId : plan._id} }">
                                <button class="btn btn-primary btn-sm">Edit</button>
                            </router-link>

                            <router-link to="/delete-plan">
                                <button class="btn btn-danger btn-sm">Delete</button>
                            </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'Plans',
    components: {

    },
    data() {
        return {
            plans: [],
            fastAdminToken : localStorage.getItem("fastAdminToken")
            // page: this.$route.params.page
        }
    },
    mounted() {

        this.$toast.open({
            message: "Processing : Loading Plans Please Wait...",
            type: 'info'
        })

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        axios.get(this.$apiURI + "/plans", config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.plans = response.data.data.plans
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    }
}
</script>
